import { render } from "./FacialHarmonizationContentPtBR.vue?vue&type=template&id=1a78c34f"
import script from "./FacialHarmonizationContentPtBR.vue?vue&type=script&lang=js"
export * from "./FacialHarmonizationContentPtBR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__